import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-10 text-center md:mb-14">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
            你可能想知道的<span className="text-gradient-gold">问题</span>
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-600/60 bg-background-900/70" : "border-background-600/60 bg-background-900/40"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className="text-sm font-semibold text-foreground-100 md:text-base">{item.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? "rotate-180 bg-primary-500 text-background-950" : "bg-background-800 text-primary-300"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 md:px-6">
                    <p className="text-sm leading-relaxed text-foreground-400">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}